import {GET_FacultyDesignation} from '../constants/ActionTypes'

const INIT_STATE = {
    Designation: null,
    //loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_FacultyDesignation:
            return {
                Designation: action.body,
                //loading :false
            }
        default:
            return state;
    }
}